import React from 'react';

import { IonGrid, IonItem, IonList, IonRow } from '@ionic/react';

import EmptyContent from 'components/EmptyContent';
import Typography from 'components/Typography';
import { useDateFormat } from 'intl';

import Status from '../Status';

export default ({ data = [] }: any) => {
  const dateFormat = useDateFormat();
  return (
    <>
      <IonList>
        {!data?.length && <EmptyContent withBorder={false} />}
        {data.map((row: any, i: number) => {
          const metaLine = `${dateFormat(row.date)} by ${row.user}`;
          return (
            <IonItem key={i} lines={'full'} className={'ellipsis'}>
              <IonGrid>
                <IonRow>
                  <Typography variant={'subtitle1'}>{row.action}</Typography>
                </IonRow>
                <IonRow>
                  <Typography variant={'subtitle2'}>{row.comment}</Typography>
                </IonRow>
                <IonRow>
                  <Typography variant={'body2'} color={'medium-shade'}>
                    {metaLine}
                  </Typography>
                </IonRow>
              </IonGrid>
              <Status value={row?.status} slot={'end'} />
            </IonItem>
          );
        })}
      </IonList>
    </>
  );
};
